<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <div>value from heroku API -> {{ apiValue }}</div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  data() {
    return {
      apiValue: ""
    };
  },
  mounted() {
    const url =
      process.env.NODE_ENV === "production"
        ? "https://nodejs-sub.herokuapp.com"
        : "http://localhost:3000";

    axios.get(`${url}/api`).then(({ data }) => {
      this.apiValue = data.api;
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
